<template>
    <div class="forgetPwdFrom" id="forgetPwdContent">
        <h2 class="sign-title" >{{$t('language.forgetPwd.title')}}</h2>
        <div class="font14">{{$t('language.forgetPwd.tip')}}</div>
        <div class="mc-row"  >
            <label for="" class="ic-label ic-email" :class="inputClass(selectInput.email)">
                <input type="text" name="email" class="width100" :placeholder="$t('language.popup.email')" autoComplete="off" v-model="email"
                    :class="inputClass(selectInput.email)"
                    @focus="focusInput('email')">
            </label>
            <p class="err tips-info" :class="tipsClass(selectInput.email)">{{tipsMsg.email}}</p>
        </div>
        <div class="turnstile-container" ref="turnstileContainer"></div>
        <div class="mc-row btn">
            <p class="err tips-info" :class="tipsClass(selectInput.btn)">{{tipsMsg.btn}}</p>
            <button class="login-btn" @click="forgetPwd()" :class="selectInput.btn=='sending'?'no-click':''">
                <span v-if="selectInput.btn=='sending'">{{$t('language.forgetPwd.sending')}}</span>
                <span v-else>{{$t('language.forgetPwd.btnTxt')}}</span>
            </button>
        </div>
        <div class="font13">
            <p class="f-margintop1">
                {{$t('language.forgetPwd.tips1')}} 
                <a class="alink" href="mailto:support@multcloud.com">{{$t('language.forgetPwd.tips2')}}</a> 
                {{$t('language.forgetPwd.tips3')}}
            </p>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import "@/assets/css/common_util.css";
import "@/assets/css/login_popup.css";
import loginUtil from "@/js/workspace/login_popup.js";
import constant from '../../../js/constant';
import common_util from '../../../js/workspace/common_util';

const TURNSTILE_SCRIPT_ID = 'cloudflare-turnstile-script';
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let turnstileScriptPromise = null;

function loadTurnstileScript() {
    if (window.turnstile) {
        return Promise.resolve(window.turnstile);
    }
    if (turnstileScriptPromise) {
        return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise((resolve, reject) => {
        let script = document.getElementById(TURNSTILE_SCRIPT_ID);
        const onLoad = () => {
            if (!window.turnstile) {
                turnstileScriptPromise = null;
                reject(new Error('Turnstile API is unavailable'));
                return;
            }
            resolve(window.turnstile);
        };
        const onError = () => {
            turnstileScriptPromise = null;
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(new Error('Failed to load Turnstile API'));
        };

        if (script) {
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            return;
        }

        script = document.createElement('script');
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
        document.head.appendChild(script);
    });
    return turnstileScriptPromise;
}

export default {
    components: {
    },
    data() {
        return {
            selectInput: {
                email: "normal",
                btn: "normal"
            },
            email: "",
            tipsMsg: {
                email: "",
                btn: "",
            },
            user: '',
            turnstileToken: '',
            turnstileWidgetId: null,
            turnstileWaiting: false,
        };
    },
    created() {

    },
    watch: {

    },
    mounted() {
        this.initPage();
        this.$nextTick(() => this.renderTurnstile());
    },
    beforeDestroy() {
        this.removeTurnstile();
    },
    methods: {
        renderTurnstile(){
            loadTurnstileScript().then(turnstile => {
                if(!this.$refs.turnstileContainer || this.turnstileWidgetId !== null) return;
                this.turnstileWidgetId = turnstile.render(this.$refs.turnstileContainer, {
                    sitekey: commonstate.turnstileSiteKey,
                    action: 'forgot_password',
                    size: 'flexible',
                    appearance: 'always',
                    theme: 'light',
                    callback: token => {
                        this.turnstileToken = token;
                    },
                    'expired-callback': () => {
                        this.resetTurnstile();
                    },
                    'timeout-callback': () => {
                        this.resetTurnstile();
                    },
                    'error-callback': () => {
                        this.turnstileToken = '';
                    }
                });
            }).catch(error => {
                this.turnstileToken = '';
                console.warn('Turnstile initialization failed:', error.message);
            });
        },
        resetTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.reset(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile reset failed:', error.message);
                }
            }
        },
        removeTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.remove(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile removal failed:', error.message);
                }
            }
            this.turnstileWidgetId = null;
        },
        waitForTurnstileToken(timeout){
            const maxWait = timeout || 5000;
            const startedAt = Date.now();
            return new Promise(resolve => {
                const checkToken = () => {
                    if(this.turnstileToken || this._isBeingDestroyed || this._isDestroyed || Date.now() - startedAt >= maxWait){
                        resolve(this.turnstileToken);
                        return;
                    }
                    setTimeout(checkToken, 100);
                };
                checkToken();
            });
        },
        toSignIn(){
            this.$parent.state='signIn';
        },
        //初始化注册页面
        initPage(){
            this.selectInput = {
                email: "normal",
                btn: "normal"
            },
            this.email = "",
            this.tipsMsg = {
                email: "",
                btn: "",
            },
            this.user="";
        },
        backSignIn(){
            this.$parent.state = "signIn";
        },
        //tips获取样式（err或suc）
        tipsClass(type){
            return loginUtil.tipsClass(type);
        },
        //获取样式
        inputClass(type){
            return loginUtil.inputClass(type);
        },
        //获取焦点后清除提示
        focusInput(type){
            loginUtil.focusInput(this,type);
        },
        /* 检查格式 */
        testEmail(){
            loginUtil.testEmail(this);
        },
        //发送忘记密码邮件
        forgetPwd(skipTurnstileWait){
            if(this.selectInput.btn=="sending") return;
            this.selectInput.btn = "normal";
            this.tipsMsg.btn = "";
            //校验参数
            this.testEmail();
            if(this.selectInput.email=="error") return;
            if(!this.turnstileToken && !skipTurnstileWait){
                if(this.turnstileWaiting) return;
                this.turnstileWaiting = true;
                this.waitForTurnstileToken(3000).then(() => {
                    this.turnstileWaiting = false;
                    if(!this._isBeingDestroyed && !this._isDestroyed){
                        this.forgetPwd(true);
                    }
                });
                return;
            }

            //准备发送邮件
            this.selectInput.btn = "sending";
            var theLang = common_util.caseIndexLanguage(this.$i18n.locale);
            var workUrl = commonstate.nowNewUrl + (theLang == 'en' ? '' : '/' + theLang) + '/reset?code=';
            var forgotData = {
                email: this.email,
                workUrl: workUrl
            }
            if(this.turnstileToken){
                forgotData.turnstileToken = this.turnstileToken;
            }

            //如果当前已存在唯一验证码，则添加多重验证唯一验证码
            if(this.$parent.dualOtp){
                if(!this.$parent.dualRember){
                    forgotData.rememberMe = false;
                }
                forgotData.otp = this.$parent.dualOtp;
                this.$parent.dualOtp = "";
            }
            this.Utils.doEmailRequest("send_forgot_code", forgotData).then(response => {
                if (response.message == "Success"&&response.status==200) {
                    this.selectInput.btn = "true";
                    this.tipsMsg.btn = "The email has been sent successfully.";
                    this.resetTurnstile();
                }else{
                    this.resetTurnstile();
                    if (response.reason == "turnstileInvalid") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = response.message || response.msg;
                    } else if (response.reason == "verifyCodeInvalid") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.verifyCodeInvalid');
                    } else if (response.reason == "emailExist") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.emailExist');
                    } else if (response.exception == "unauthorizedEquipment") {
                        //进入多重验证
                        this.$parent.dual = response.dual;
                        this.$parent.dualOtp = response.otp;
                        this.$parent.backState = "forgetPwd";
                        this.$parent.getVerifyMessage("verify");
                    } else if(response.exception == "pendingActivated") {
                        //进入修改验证进行中页面
                        this.$parent.dual = response.dual;
                        this.$parent.dualOtp = response.otp;
                        this.$parent.backState = "forgetPwd";
                        this.$parent.getVerifyMessage("recovery-pending")
                    }else{
                        this.selectInput.btn = "normal";
                    }
                }
            }, () => {
                this.resetTurnstile();
                this.selectInput.btn = "error";
            })
        },
    }
};
</script>

<style scoped>
.turnstile-container {
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/popup/share_page_popups/forget_pwd_popup.vue